module.exports = __webpack_public_path__ + "static/img/draw_gif_preview.ad126b8b.png";